import * as React from 'react'
import { Omit } from '../types'

const wrapDisplayName = (BaseComponent: React.ComponentType, hocName: string) =>
  `${hocName}(${BaseComponent.displayName || 'Component'})`

export function withProps<NewProps extends {}>(props: NewProps) {
  return function wrapper<ComponentProps extends NewProps>(
    UnwrappedComponent: React.ComponentType<ComponentProps>
  ) {
    type Props = Omit<ComponentProps, keyof NewProps>

    class WithProps extends React.Component<Props> {
      static readonly displayName = wrapDisplayName(
        UnwrappedComponent,
        'withProps'
      )

      render() {
        return <UnwrappedComponent {...props} {...this.props} />
      }
    }

    return WithProps
  }
}



// WEBPACK FOOTER //
// ./src/utils/components.tsx